var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1119_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 19.5595C6 20.6918 6.9 21.6183 8 21.6183H16C17.1 21.6183 18 20.6918 18 19.5595V7.20651H6V19.5595ZM19 4.11828H15.5L14.5 3.08887H9.5L8.5 4.11828H5V6.1771H19V4.11828Z",
    fill: "#1E3859"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1119_3059"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.000488281,
    width: 24,
    height: 24.7059,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.68294752d1de8087ee14aea28f369f97.svg";
export { ForwardRef as ReactComponent };